import { render, staticRenderFns } from "./dialog-add-account.vue?vue&type=template&id=0baa429c&scoped=true&"
import script from "./dialog-add-account.vue?vue&type=script&lang=ts&"
export * from "./dialog-add-account.vue?vue&type=script&lang=ts&"
import style0 from "./dialog-add-account.vue?vue&type=style&index=0&id=0baa429c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baa429c",
  null
  
)

export default component.exports